<app-report-runner
  reportType="geographic-distribution"
  title="Geographic Distribution Report"
  description="Distribution of clients, cases, services, and outreach by ZIP Code."
/>
